module.exports = __webpack_public_path__ + "static/CC-bd32ae2e5c833902dea870d54e982373.jpg";